import Loading from '@/components/shared/Loading'
import { useAppSelector } from '@/store'
import useAuth from '@/utils/hooks/useAuth'
import useDirection from '@/utils/hooks/useDirection'
import useLocale from '@/utils/hooks/useLocale'
import { Suspense, lazy, useMemo } from 'react'

const layouts = {
   CompanyBaseLayout: lazy(() => import('./Company/SimpleLayout')),
   AccountantBaseLayout: lazy(() => import('./Accountant/SimpleLayout')),
}

const Layout = () => {
   const layoutType = useAppSelector((state) => state.theme.layout.type)

   const { authenticated, isAccountant } = useAuth()

   useDirection()

   useLocale()

   const AppLayout = useMemo(() => {
      if (authenticated) {
         if (isAccountant === true) {
            return layouts.AccountantBaseLayout
         }

         if (isAccountant === false) {
            return layouts.CompanyBaseLayout
         }
      }
      return lazy(() => import('./AuthLayout'))
   }, [layoutType, authenticated, isAccountant])

   return (
      <Suspense
         fallback={
            <div className="flex flex-auto flex-col h-[100vh]">
               <Loading loading={true} />
            </div>
         }
      >
         <AppLayout />
      </Suspense>
   )
}

export default Layout
